import React, {useEffect, useId, useRef} from 'react';
import {createPortal} from 'react-dom';

export default function Modal({title, children, onClose, busy=false, wide=false}) {
  const ref = useRef(null);
  const id = useId();
  useEffect(() => {
    const previous = document.activeElement;
    const overflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    ref.current?.focus();
    return () => {document.body.style.overflow = overflow; previous?.focus();};
  }, []);
  const keys = e => {
    if (e.key === 'Escape' && !busy) onClose();
    if (e.key !== 'Tab') return;
    const items = [...ref.current.querySelectorAll('button:not(:disabled), input:not(:disabled), select:not(:disabled), textarea:not(:disabled), a[href]')];
    const first = items[0], last = items[items.length - 1];
    if (!first) {e.preventDefault(); return;}
    if (e.shiftKey && (document.activeElement === first || document.activeElement === ref.current)) {e.preventDefault();last.focus();}
    else if (!e.shiftKey && (document.activeElement === last || document.activeElement === ref.current)) {e.preventDefault();first.focus();}
  };
  return createPortal(<div className="design-modal-backdrop" onMouseDown={e=>{if(e.target===e.currentTarget&&!busy)onClose();}}>
    <section className={`design-modal ${wide?'design-modal-wide':''}`} role="dialog" aria-modal="true" aria-labelledby={id} tabIndex={-1} ref={ref} onKeyDown={keys}>
      <header className="design-modal-header"><h2 id={id}>{title}</h2><button type="button" className="icon-button" aria-label="Close dialog" disabled={busy} onClick={onClose}>×</button></header>
      <div className="design-modal-body">{children}</div>
    </section>
  </div>, document.body);
}
